export const disabled = {
  cursor: 'default',
  opacity: 'disabled',
  pointerEvents: 'none',
};
